var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M21 12c0-4.968-4.032-9-9-9s-9 4.032-9 9 4.032 9 9 9 9-4.032 9-9zm-6.3-4.95l2.835 2.835c.18.18.18.459 0 .639L14.7 13.35V11.1h-3.6V9.3h3.6V7.05zm-5.4 9.9l-2.835-2.835a.446.446 0 0 1 0-.639L9.3 10.65v2.25h3.6v1.8H9.3v2.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6E0D83",
    d: "M-33-34H67V66H-33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32122F",
    d: "M-33-34H67V66H-33z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchSvg);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiAgdmlld0JveD0iMCAwIDI0IDI0IiB4PSIwcHgiIHk9IjBweCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTIxIDEyYzAtNC45NjgtNC4wMzItOS05LTlzLTkgNC4wMzItOSA5IDQuMDMyIDkgOSA5IDktNC4wMzIgOS05em0tNi4zLTQuOTVsMi44MzUgMi44MzVjLjE4LjE4LjE4LjQ1OSAwIC42MzlMMTQuNyAxMy4zNVYxMS4xaC0zLjZWOS4zaDMuNlY3LjA1em0tNS40IDkuOWwtMi44MzUtMi44MzVhLjQ0Ni40NDYgMCAwIDEgMC0uNjM5TDkuMyAxMC42NXYyLjI1aDMuNnYxLjhIOS4zdjIuMjV6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8ZyBtYXNrPSJ1cmwoI2IpIj4KICAgICAgICAgICAgPHBhdGggZmlsbD0iIzZFMEQ4MyIgZD0iTS0zMy0zNEg2N1Y2NkgtMzN6Ii8+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMzMjEyMkYiIGQ9Ik0tMzMtMzRINjdWNjZILTMzeiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };